import { logger } from '../../utilities/logger';
import { useCustomEventListener } from '../../hooks/use_custom_event_listener';
import { useState } from 'react';
import { captureException } from '@sentry/react';
import { Nullable } from '../../utilities/common_types';
import { version as workplaceLoaderVersion } from '../../../package.json';
import { registerHeaderProvider } from '../../gql/apollo_register_header_provider';
import { errorChecker } from '../../utilities/error_checker';
import { useAppState } from '../../contexts/app_state/use_app_state_context';

export const INITIALISE_EVENT_KEY = 'initialise';
const WORKPLACE_MOBILE_CHANNEL_ID = 'c69972ed-7f21-4d66-91e7-9428980109c7';

function buildApiUrl(apiEndpointUrl: string) {
  try {
    const apiUrl = new URL(apiEndpointUrl);
    const pathnameArray = apiUrl.pathname.split('/').filter(Boolean);
    pathnameArray.push('graphql');
    apiUrl.pathname = pathnameArray.join('/');
    return apiUrl.toString();
  } catch (error) {
    logger.error({
      error: errorChecker(error),
      message: 'useInitialise:setApiEndpoint failed',
      extra: {
        apiEndpointUrl,
      },
    });
    captureException(error);
  }
  return null;
}

function setChannelId(channelId: string) {
  sessionStorage.setItem('poppulo-x-channel-id', JSON.stringify(channelId));
  registerHeaderProvider('x-channel-id', () => channelId);
}

function setChannelVersion() {
  const nativeAppVersion = 'unknown';
  // Poppulo-x-channel-version format = {nativeAppVersion}-{workplaceLoaderVersion}
  const channelVersion = nativeAppVersion.concat('-', workplaceLoaderVersion);
  sessionStorage.setItem('poppulo-x-channel-version', JSON.stringify(channelVersion));
  registerHeaderProvider('x-channel-version', () => channelVersion);
}
export function useInitialise() {
  const [apiEndpoint, setApiEndpoint] = useState<Nullable<string>>(null);
  const { setIsInitialised } = useAppState();

  useCustomEventListener(INITIALISE_EVENT_KEY, (event) => {
    logger.debug({
      message: `${INITIALISE_EVENT_KEY} event received`,
      extra: {
        detail: event.detail,
      },
    });
    const apiUrl = buildApiUrl(event.detail.apiEndpoint);
    if (apiUrl) {
      setApiEndpoint(apiUrl);
      setChannelId(WORKPLACE_MOBILE_CHANNEL_ID);
      setChannelVersion();
      window.FeedsWebViewApi.postToken(event.detail.token, event.detail.expire);
      window.FeedsWebViewApi.setPreferredLanguage(event.detail.locale);
      window.FeedsWebViewApi.deepLinkPost(event.detail.route);
      setIsInitialised(true);
    }
  });
  return {
    apiEndpoint,
  };
}
